/**
 * Configuración por ambiente (Twelve-Factor): llega en variables VITE_* al construir, nunca en el código.
 * Se valida al arrancar: una configuración incompleta falla de inmediato y no a mitad de una sesión.
 */
import { z } from "zod";

const esquema = z
  .object({
    VITE_API_URL: z.url().optional(),
    /** Dominio de Cognito del directorio interno (salida `UrlIngresoAdmin` de la pila). */
    VITE_COGNITO_DOMINIO: z
      .url()
      .regex(/^https:\/\/[a-z0-9-]+\.auth\.[a-z]{2}-[a-z]+-\d\.amazoncognito\.com$/)
      .optional(),
    VITE_COGNITO_CLIENTE: z
      .string()
      .regex(/^[a-z0-9]{20,32}$/)
      .optional(),
    VITE_DEMO: z.enum(["true", "false"]).default("false"),
    PROD: z.boolean(),
  })
  .superRefine((e, ctx) => {
    if (e.PROD && e.VITE_DEMO === "true") {
      ctx.addIssue({ code: "custom", message: "El modo demostración no se publica." });
    }
    if (e.VITE_DEMO === "false" && (!e.VITE_API_URL || !e.VITE_COGNITO_DOMINIO || !e.VITE_COGNITO_CLIENTE)) {
      ctx.addIssue({ code: "custom", message: "Faltan VITE_API_URL, VITE_COGNITO_DOMINIO o VITE_COGNITO_CLIENTE." });
    }
  });

export interface Entorno {
  readonly demo: boolean;
  readonly apiUrl: string;
  readonly cognito: { readonly dominio: string; readonly clienteId: string };
}

export function leerEntorno(variables: Record<string, unknown>): Entorno {
  const e = esquema.parse(variables);
  return {
    demo: e.VITE_DEMO === "true",
    apiUrl: e.VITE_API_URL ?? "http://demo.invalid",
    cognito: { dominio: e.VITE_COGNITO_DOMINIO ?? "https://demo.invalid", clienteId: e.VITE_COGNITO_CLIENTE ?? "demo" },
  };
}
